//test
export const getCount = state => {
    return state.count
}
export const getuserCode = state => {
    return state.userCode
}